import { FC, useMemo, useState } from "react";
import { Table} from "antd";

interface ContactIndexTableProps {
    isLoading: boolean;
    contactIndexData : any[];
}

export const ContactIndexTable: FC<ContactIndexTableProps> = ({ isLoading, contactIndexData }) => {

    const [currentPage, setCurrentPage] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(12);
    const HEADERS_FORMS_TABLE = useMemo(() => [        
        {
            title: 'Apellido y/o Nombre',
            key: 'nombre',
            dataIndex: 'nombre'
        },
        {
            title: 'Área',
            key: 'nombreArea',
            dataIndex: 'nombreArea'
        },
        {
            title: 'Email',
            key: 'mail',
            dataIndex: 'mail'
        },
        {
            title: 'Teléfono e Interno',
            key: 'nroContacto',
            dataIndex: 'nroContacto'
        },
    ], []);

    return (
        
        <Table
            loading={isLoading}
            bordered
            className='w-100'
            columns={HEADERS_FORMS_TABLE}
            dataSource={contactIndexData || []}
            pagination={{
                current: currentPage,
                pageSize: pageSize,
                showSizeChanger: true,
                pageSizeOptions: ['12', '24', '48', '96'],
                onChange: (page, pageSize) => {
                    setCurrentPage(page);
                    setPageSize(pageSize);
                },
            }}
            rowKey={(record) => record.mail}
        />
    );
}
